<template>
  <div>
    <CChartPie :datasets="dataSet" :options="options" :labels="label" />
  </div> 
</template>

<script>
import { CChartPie } from "@coreui/vue-chartjs";
import { getStyle, hexToRgba } from "@coreui/utils/src";

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default {
  name: "ProductChart",
  components: {
    CChartPie,
  },
  props: {
    dataSet: {
      type: [Array, Object],
      default: () => [],
    },
    label: {
      type: [Array, Object],
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        maintainAspectRatio: true,
        responsive:true,
        legend: {
          display: true,
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3,
          },
        },
      },
    };
  },
};
</script>
